enum ApprovalStateEnum {
	None = 'none',
	Pending = 'pending',
	Accepted = 'accept',
	Declined = 'declined',
}

export default ApprovalStateEnum;
